import {
    Box,
    Button,
    Modal,
    SpaceBetween,
    TextContent,
} from '@cloudscape-design/components';
import '../styles/preferences-pane.scss';
import Content from './Content';

interface ExploreModalProps {
    exploreModalOpen: boolean;
    setExploreModalOpen: (isOpen: boolean) => void;
}

export default function ExploreModal({
    exploreModalOpen,
    setExploreModalOpen,
}: ExploreModalProps) {
    const onDismiss = () => {
        // For use on learning-artifact-detail page
        window.location.hash = window.location.hash.split('?')[0];
        setExploreModalOpen(false);
    };
    return (
        <Modal onDismiss={onDismiss} visible={exploreModalOpen} size="max">
            <Content modalVersion setExploreModalOpen={setExploreModalOpen} />
        </Modal>
    );
}
